import * as types from './types'

export const getEmergenciesRequest = () => ({
  type: types.GET_EMERGENCIES_REQUEST,
  loading: true,
})
export const getEmergenciesSuccess = (payload) => ({
  type: types.GET_EMERGENCIES_SUCCESS,
  payload,
})
export const getEmergenciesError = (error) => ({
  type: types.GET_EMERGENCIES_ERROR,
  payload: error,
})

export const createEmergencyRequest = () => ({
  type: types.CREATE_EMERGENCY_REQUEST,
})
export const createEmergencySuccess = (msg) => ({
  type: types.CREATE_EMERGENCY_SUCCESS,
  payload: { msg },
})
export const createEmergencyError = (error) => ({
  type: types.CREATE_EMERGENCY_ERROR,
  payload: error,
})
